import CityPageTemplate from "../city-template/CityPageTemplate";
import { cantonConfig } from "./data";

export default function CantonMIPage() {
  return <CityPageTemplate config={cantonConfig} />;
}